import { Icon, MenuItem, MenuSectionLabel, Popover } from '@/components/ui';

import { currentTenantName, useTenantStore } from '../../auth/tenantStore';

export function TenantSwitcher() {
  const me = useTenantStore((s) => s.me);
  const currentTenantId = useTenantStore((s) => s.currentTenantId);
  const setCurrentTenant = useTenantStore((s) => s.setCurrentTenant);
  const tenantName = useTenantStore(currentTenantName);

  if (!me) return null;

  // Switching tenant must reload the current page so every mounted view re-fetches
  // for the new tenant (the active tenant rides on the X-Tenant-Id request header,
  // not the URL, so a soft state change can leave stale data on screen). The chosen
  // id is persisted to localStorage (datahub.tenant.v1), so the reload restores it
  // via AuthProvider/pickDefaultTenantId. NB: keep the reload here, in the user
  // gesture only — never in tenantStore.setCurrentTenant, which also runs during
  // bootstrap and would otherwise reload-loop.
  const switchTenant = (id: string) => {
    if (id === currentTenantId) return;
    setCurrentTenant(id);
    window.location.reload();
  };

  const activeMemberships = me.memberships.filter((m) => m.status === 'active');
  const label = tenantName || 'Select tenant';

  return (
    <Popover
      placement="bottom-start"
      matchTriggerWidth
      trigger={
        <button type="button" className="tenant-switcher-trigger" aria-label="Switch tenant">
          <Icon name="globe" className="tenant-switcher-icon" />
          <span className="tenant-switcher-label">
            <span className="tenant-switcher-name">{label}</span>
          </span>
        </button>
      }
    >
      {({ close }) => (
        <div className="tenant-switcher-menu">
          {activeMemberships.length > 0 && (
            <>
              <MenuSectionLabel>{me.isSuperAdmin ? 'All tenants' : 'Your tenants'}</MenuSectionLabel>
              {activeMemberships.map((m) => (
                <MenuItem
                  key={m.tenantId}
                  onClick={() => {
                    switchTenant(m.tenantId);
                    close();
                  }}
                >
                  <span className="tenant-switcher-row">
                    <span className="tenant-switcher-row-name">{m.tenantName}</span>
                    <Icon
                      name="check"
                      className="tenant-switcher-check"
                      style={{
                        visibility: m.tenantId === currentTenantId ? 'visible' : 'hidden',
                      }}
                    />
                  </span>
                </MenuItem>
              ))}
            </>
          )}
        </div>
      )}
    </Popover>
  );
}
